import { render, staticRenderFns } from "./KaiSuccessCtaButton.vue?vue&type=template&id=379c7b8a&scoped=true&"
var script = {}
import style0 from "./KaiSuccessCtaButton.vue?vue&type=style&index=0&id=379c7b8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "379c7b8a",
  null
  
)

export default component.exports